import Api from './api';

(function() {
    let timer, scrolls = {};

    function onScrolled() {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(finishedScrolling, 1000);
    }
    async function finishedScrolling() {
        timer = null;

        const now = +new Date();
        var features = document.getElementsByClassName('scroll-tracker');
        let maxOverlap = 0;
        let bestFeature;
        for(let i=0;i<features.length;++i) {
            const f = features[i];
            const rect = f.getBoundingClientRect(); // relative coordinates
            const top = rect.y;
            const bottom = rect.y + rect.height;                
            const overlap = Math.max(0, Math.min(bottom, window.innerHeight) - Math.max(top, 0));
            if (overlap > maxOverlap) {
                maxOverlap = overlap;
                bestFeature = f.id;
            }
        }
        if (bestFeature) {
            const prevTime = scrolls[bestFeature];
            if (!prevTime || now - prevTime > 1000) {
                scrolls[bestFeature] = +new Date();
                await Api.event("new-home", "page", "scrolled", bestFeature, "");
            }
        }
    };


    async function initializeScrollTracker() {
        window.addEventListener('scroll', onScrolled, {passive: true});
    }

    window.addEventListener('DOMContentLoaded', () => {
        initializeScrollTracker();
    });
})();
